import React, { useState } from "react";
import { Button, message } from "antd";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";

import UNSKIP_TOPIC from "graphql/mutations/UnskipTopic";

import UnskipTopicModal from "pages/my_level/UnskipTopicModal";

interface UnskipTopicButtonProps {
  targetTopicId: number;
  unskippedSuccessFn: () => void;
}

const UnskipTopicButton = ({
  targetTopicId,
  unskippedSuccessFn,
}: UnskipTopicButtonProps) => {
  const { t } = useTranslation("class_details");

  const [isUnskipTopicModalVisible, setUnskipTopicModalVisible] =
    useState(false);

  const handleOpenUnskipTopicModal = () => setUnskipTopicModalVisible(true);
  const handleCloseUnskipTopicModal = () => setUnskipTopicModalVisible(false);

  const [unskipTopic] = useMutation(UNSKIP_TOPIC, {
    onCompleted: () => {
      handleCloseUnskipTopicModal();
      unskippedSuccessFn();
      message.success(t("Your topic was un-skipped."));
    },
    onError: () => {
      handleCloseUnskipTopicModal();
      message.error(t("Cannot un-skip this topic."));
    },
  });

  const handleConfirmSkipTopic = () => {
    unskipTopic({
      variables: {
        id: targetTopicId,
      },
    });
  };

  return (
    <>
      <Button
        className="section-button size-2 skip-button"
        name="unskipTopic"
        type="primary"
        onClick={() => handleOpenUnskipTopicModal()}
      >
        {t("UNSKIP THIS TOPIC")}
      </Button>
      <UnskipTopicModal
        visible={isUnskipTopicModalVisible}
        onConfirm={handleConfirmSkipTopic}
        onCancel={handleCloseUnskipTopicModal}
      />
    </>
  );
};

export default UnskipTopicButton;
